import React from 'react';
import {
  DialogActions,
  DialogContentText,
  CardMedia,
  DialogContent,
  IconButton,
  DialogTitle,
  Dialog,
  useTheme,
  useMediaQuery,
  Typography
} from '@mui/material';
import cancel from '../../../assets/images/logos/cancel.svg';

const Terms = (props) => {
  console.log('props', props);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={props.open}
        onClose={props.handleClose}
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" variant="h2">
          {'Legal Terms & Conditions'}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={props.handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 5,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CardMedia component="img" image={cancel} alt="cancel" />
        </IconButton>
        <DialogContent sx={{ color: '#282828', textAlign: 'justify' }}>
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            This document lays out the terms and conditions that apply to the access and use of the FINVESTA platform through the website
            “www.fiaglobal.com” (herein after referred to as “Website”), FINVESTA- Online service platform, (herein after referred to as
            “App”) and any other sub-domain or platform which is owned, developed, managed or operated by FIA Technology Services Private
            Limited, (hereinafter referred to as “FIA”) or which provides a link to the App or Website.{' '}
          </DialogContentText>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            In terms of Information Technology Act, 2000, this document is an electronic record, being generated by a computer system and it
            does not require any physical or digital signature. Your acceptance to the terms and conditions shall be considered as your
            consent to use the App, the Website, the services and products (collectively referred to herein as “Services”) provided by
            FINVESTA in accordance with the terms and conditions laid down by FIA.
            <br />
            These Terms and Conditions are published in accordance with the provisions of Rule 3 (1) of the Information Technology
            (Intermediaries Guidelines) Rules, 2011 that require publishing the rules and regulations, privacy policy and user agreement for
            access or usage of the intermediary’s computer resource by any person.
          </DialogContentText>
          <br />
          <br />
          <Typography id="responsive-dialog-title" variant="h3">
            {'Interpretation '}
          </Typography>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            The words, “him”, “his”, “You”, “Your”, “Client”, “User” “Investor”, “I”, “Subscriber” and “Customer” refer to the person(s) who
            use and avail the Services and Products of FIA Website / App and shall include both singular and plural. The Services provided
            herein is only for Customers who are Indian citizens and tax resident of India.
            <br />
            These terms shall constitute a binding contract between FIA and you when you download the App or use the services on Website and
            / or the App or use its Services on any other platform managed by FIA and shall be referred to herein as the “Agreement”.
            Downloading and installing the App or using the services of the Website or the App shall be deemed to constitute sufficient
            proof that you have read, understood and accepted these terms.
            <br />
            These Terms and Conditions contain important information regarding the Services that FINVESTA will provide to you and for your
            own protection you should read them carefully before accepting them. If you do not agree to these terms you must not proceed to
            use the App or use the Services provided on the website or mobile application.
            <br />
            This Agreement may be read with our privacy policy document or other such documents as may apply to a particular account /
            service / situation / circumstance / transaction.
            <br />
            Reference to any statute, ordinance or other law includes all regulations and other instruments and all consolidations,
            amendments, re-enactments or replacements for the time being in force. All headings, bold typing and italics (if any) have been
            inserted for convenience of reference only and do not define limit or affect the meaning or interpretation of the terms
            contained herein.
            <br />
            Without prejudice to any other specific requirement which may be laid out in this Agreement, your use of the App / Website and
            the Services and specifically, your acceptance of these terms as aforesaid shall be deemed to be a representation from you that
            you are above 18 years of age, or possess legal parental or guardian consent, and are fully able, conscious and competent to
            enter into this Agreement and make your investment decisions, execute the investment transactions, evaluate the advice, if any,
            and confirm to abide by and comply with the terms set forth herein.
            <br />
            <br />
          </DialogContentText>
          <br />
          <Typography id="responsive-dialog-title" variant="h3">
            {'Description of the FINVESTA App / Website'}
          </Typography>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            FINVESTA (including the App and Website) is owned by FIA Technology Services Private Limited, a company incorporated under the
            Companies Act, 1956 and having its registered office at FIA Technology Services Private Limited 1017 A – 1017 I,, JMD Megapolis,
            Sohna Road, Sector - 48, Gurugram, Haryana 122018 FINVESTA is in the business of providing investment and wealth management
            services to users through its technology platforms.
            <br />
            FINVESTA shall through its Website / App provide mutual fund investment execution and advisory services. FINVESTA shall use the
            information you provide about your investment and risk assessment to make investment recommendations to you in the form of one
            or more suitable Mutual Fund Schemes provided by Asset Management Companies / Mutual Funds. The advice or information that is
            visible on FINVESTA would be prepared on the basis of information available with FIA, including data which it receives from the
            3rd Parties offering the product and FINVESTA would not independently verify the said information and also based on Company’s
            understanding of assessing risk and suitability in line with your objectives, profile, and requirements as per the details /
            information provided by you. FINVESTA does not take any fees or commissions from the Mutual Fund schemes it recommends. Upon
            receipt of the advice, you may decide whether to disregard it (in whole or in part) or to act upon it (in whole or in part). All
            investment decisions shall be made at your sole discretion. You are free to choose execution of Mutual Funds you want to invest
            in, irrespective of whether you have obtained advisory from FINVESTA or not. You are free to use FINVESTA platform or any other
            platform at your free will to make investment when you have received advisory from FIA. Mere view of certain Mutual Funds
            information on the App or Website does not amount to advisory. While providing Advisory Services, FINVESTA has not undertaken
            any regulatory, legal, tax or accounting analysis relating to the suitability of the products invested by you. You should seek
            appropriate professional advice including tax advice before dealing with any realised or unrealised gain / loss reflecting in
            the investments, portfolio or statement.
            <br />
          </DialogContentText>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            In addition to providing Investment Advisory services, FINVESTA also provides the service for Users to make or execute direct
            investments (i.e., investments not routed through a distributor) from the FINVESTA Website / App. FINVESTA will transmit all
            your funds request and instructions to the Asset Management Companies (“AMC”) or its authorized Registrar and Transfer Agent
            (RTA). FINVESTA is only an order collection platform that collects orders on behalf of you and places them for execution. You
            expressly agree that FINVESTA would not be liable or responsible and does not represent or warrant for any damages regarding
            non-execution of orders or any incorrect execution of orders with regard to the Mutual fund schemes chosen by you due to, but
            not being limited to, any link / system failure, failure at third party service providers, etc.
            <br />
            FINVESTA shall also maintain a record of your personal information and transactions i.e Portfolio Information. FINVESTA can
            collect the daily NAV & other MF scheme related information from AMFI website or Authorized Registrar and Transfer Agents (RTAs)
            of the AMCs or third party vendors or the AMCs themselves, and process it in order to update the investor’s portfolio
            information. FINVESTA makes best efforts to ensure that the information is correct and updated at all times. However, as the
            information is received from a third party, FINVESTA will not be responsible for any incorrect information on the platform. To
            verify validity of any information about mutual fund schemes or information about your investments in mutual fund schemes,
            FINVESTA suggests that you contact respective AMCs or their respective RTAs.
            <br />
            FINVESTA uses Application Programming Interfaces and portals provided by third party service providers to facilitate Mutual fund
            transactions. FINVESTA maintains the status of the transactions, account-opening status, KYC, portfolio etc. based on the data
            provided by the third party service providers and as per the regulations prescribed from time to time.
            <br />
            FINVESTA provides access to paperless switch to direct schemes based on the details provided by User. The User hereby gives
            FINVESTA unconditional consent to verify the details with the AMC / RTA / KRA / CERSAI / Tax Department.
          </DialogContentText>
          <br />
          <br />
          <Typography id="responsive-dialog-title" variant="h3">
            {'Use of the App / Website / Service'}
          </Typography>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            User will be allowed to avail or use the services only when the User completes the KYC, Investment Readiness and Information
            Verification process and provides the complete personal information in accordance with the Know Your Client (“KYC”) guidelines
            issued by the Securities and Exchange Board of India (“SEBI”), AMCs, RTAs, or any other regulatory / government agencies or
            authorities from time to time. FINVESTA may use your personal data and in order to provide services to you, your personal
            information may be processed by or transferred or disclosed to and / or by third parties like AMC’s, RTA’s, KRAs, CERSAI,
            Statutory Bodies or Agency, or 3rd party service providers & partners etc. where necessary to enable us to provide services to
            you. With your consent, your personal information and usage of the website / mobile app / services of FINVESTA may be used by us
            in order to provide you with information, user experience and marketing materials in relation to other products and services. By
            entering into this Agreement, you confirm your consent for your personal information to be processed for these additional
            purposes. If you do not agree with these terms, we suggest you do not signup or avail any services offered by FIA.
            <br />
            You may avail the Services by using your FINVESTA user id and password which is provided by FIA technology Services Private
            Limited. You agree and that you shall be solely responsible to ensure protection and confidentiality of the user ID and password
            at all times and any disclosure thereof shall be entirely at your risk. You shall not use the App / Website / Service for any
            commercial purpose.
            <br />
            <br />
            In your use of the App / Website / Service, you shall always comply with all applicable laws.
            <br />
            <br />
            You agree not to circumvent, disable or otherwise interfere with security-related features of the App / Website / Service or
            features that prevent or restrict use or copying of any content or enforce limitations on use of the App or the content therein.
            <br />
            <br />
            Except for the Services explicitly provided, FINVESTA does not provide, control or endorse any third party information, products
            or services in any manner whatsoever, even if such third party information, products or services are displayed / featured on the
            App / Website.
            <br />
            <br />
            You hereby represent and warrant that you shall make use of the App / Website / Service as a prudent, reasonable and law-abiding
            citizen of India.
            <br />
            <br />
            FINVESTA shall not be responsible for any delay or failure in processing any transaction or any request whatsoever resulting
            from infrastructure issues, server uptime, network availability and connectivity etc.
            <br />
            <br />
            You shall not take any action that would cause FINVESTA to suffer any type of losses. You shall notify FINVESTA of any material
            change in your situation and / or profile and FINVESTA would rely on the most recent information provided by you.
            <br />
            <br />
            FINVESTA does not take the responsibility, liability and undertake the authenticity of the figures calculated on the basis of
            calculator provided herein for calculations towards prospective investments. The data content provided is obtained from sources
            considered to be authentic and reliable. However, FINVESTA is neither responsible nor liable for any error or inaccuracy or for
            any losses suffered on account of information.
          </DialogContentText>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            FINVESTA has the sole authority and right to reject a Customer’s request to open an account with FIA . FINVESTA may at its
            discretion choose to disclose or not disclose the reason for not opening such account. FINVESTA may also reject / suspend /
            freeze Customer’s request to open or operate his or her account on directions received from regulatory or government bodies &
            authorities.
            <br />
            <br />
            The Calculators / Tools / Planners are designed to assist you in determining the appropriate amount. These Calculators / Tools /
            Planners alone are not sufficient and shouldn’t be used for the development or implementation of an investment strategy. You are
            requested to make your investment decisions at your own will and value judgement.
            <br />
            <br />
            I hereby authorize FINVESTA to share with Mutual Fund, AMC, RTAs and the Trustees, my signature available on the records of the
            KYC Registration Agency (“KRA”) or CKYC for authenticating and processing my requests.
            <br />
            <br />
            Any action taken by Mutual Fund / AMC / its Registrar / the Trustees in good faith relying on the information / evidences /
            specimen (including specimen signature) available from the records of the KRA / CKYC will be a valid discharge for Mutual Fund /
            AMC / its Registrar / the Trustees. I shall not have any recourse against Mutual Fund / AMC / its Registrar / the Trustees for
            any such action taken in good faith relying on records or information available with the KRA / CKYC.
            <br />
            <br />
            In case my signatures are not available with KRA / CKYC, I agree to co-operate with AMC / FINVESTA/ RTA to provide incremental
            details as may be required by AMC / FINVESTA/ RTA to complete verification.
            <br />
            <br />
            I agree NAV allotment shall be as per prescribed guidelines by AMC accordingly to receipt of funds.
            <br />
            <br />
            I understand that all entities are acting within scope of guidelines / regulations defined or suggested by SEBI / AMFI and other
            regulators.
            <br />
            <br />
            The Customer agrees, acknowledges and provides his / her consent that the information provided by him / her may be shared with
            regulators / government bodies as and when required or requested by them.
          </DialogContentText>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            The Customer understands and consents to record his / her telephonic conversations with the customer support department (managed
            by itself or through any outsourced vendor) for quality control, record retention purposes, and other similar purposes however
            we agree to keep such records confidential.
            <br />
            <br />
            The Customer understands that he / she can login through his / her specific User Login Credentials. By logging into the FINVESTA
            App / Website using these credentials, the Customer acknowledges and provides consent to verify his / her credentials with FIA
            Technology Services Private Limited.
            <br />
            <br />
            The customer understands and consents that all the transactions, financial or non-financial, carried out by the customer through
            the FINVESTA App or Website or through any other intermediary in relation to FIA Technology Services Private Limited, shall be
            tagged to the code of FINVESTA i.e. “……………………”.
            <br />
            <br />
            The Customer hereby authorize and consents to all AMCs with whom he / she transact with to share and disclose the details of his
            / her personal data and information including the details of his / her investments and transactions in the Schemes of the Mutual
            Fund made through the code “………………………..” to FIA Technology Services Private Limited.
            <br />
            <br />
            All investments through the FINVESTA Platform shall be made at the sole discretion of the User and all investments will be
            executed by the User only or as per the directions issued by the User.
            <br />
            <br />
            The User hereby allow FINVESTA to utilize his / her KYC information, which the User has submitted as its own will or uploaded on
            FIA Technology Services Private Limited’s system or wesite, such as his / her personal identity details like name, PAN, age,
            address, mobile number, email address and signature or any such prescribed by FINVESTA or by regulation for sending / sharing it
            to any Asset Management Companies (AMC) or RTA (Registrar and Transfer Agent) or KYC authority (UIDAI, KRA, CERSAI, or others)
            for the purpose of validation and to comply with the legal and regulatory requirements. The User shall be solely liable to
            inform FINVESTA/ AMC in case of any change in the KYC information including and any investment information or declaration or
            change in signature / signatories etc. and in the event of his / her signature not being updated, available or legible in KYC
            records, FINVESTA/ AMC would be within its rights to carry out further checks to validate the authenticity of the request or
            reject any such request based on existing KYC information. The User shall provide such additional documents and perform such
            additional actions that may be called upon to be submitted by FIA. In case the User’s signatures is not available with KRA /
            CKYC, the User shall co-operate with AMC / FINVESTA/ RTA to provide incremental details as may be required by AMC / RTA to
            complete verification.
            <br />
            <br />
            The User hereby authorizes FINVESTA to share with Mutual Fund, AMC, RTAs and the Trustees, his / her signatures available on the
            records of the KYC Registration Agency (“KRA”) or CKYC for authenticating and processing requests.
            <br />
            <br />
            Any action taken by Mutual Fund / AMC / its Registrar / the Trustees / FINVESTA in good faith relying on the information /
            evidences / specimen (including specimen signature) available from the records of the KRA / CKYC will be a valid discharge for
            Mutual Fund / AMC / its Registrar / the Trustees. The User shall not have any recourse against Mutual Fund / AMC / its Registrar
            / the Trustees / FIA for any such action taken in good faith relying on records or information available with the KRA / CKYC.
          </DialogContentText>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            The User hereby confirms and acknowledges that the information provided by the User hereunder or thereafter after the login to
            the FINVESTA App or Website may be used by FINVESTA for marketing purposes and cross selling purposes.
            <br />
            <br />
            The User hereby declares that all amount invested in the schemes through the FINVESTA platform shall be through his / her own
            legitimate source / Bank Account only and the said investments do not contravene any Act, Rules, Regulations, Notifications or
            Directives of the provisions of the Income Tax Act, Anti Money Laundering Laws, Anti-Corruption Laws or any other applicable
            laws enacted by the Government of India from time to time.
            <br />
            <br />
            The User hereby agrees and acknowledges that he / she has not received nor have been induced by any rebate or gifts, directly or
            indirectly in making this investment. The User confirms that the funds invested in the Scheme, legally belongs to the User. The
            User understand that if any investment is made through any 3rd party Account then the same is liable to be rejected by FINVESTA
            or the AMC. In the event “Know Your Client” process is not completed by the User to the satisfaction of the FINVESTA/ AMC /
            Mutual Fund, the User hereby authorizes the AMC / Mutual Fund in its sole discretion to redeem the funds invested in the Scheme
            at the applicable NAV prevailing on the date of such redemption and undertake to abide by such other action with such funds may
            be required to do under law.
            <br />
            <br />
            The User hereby gives his / her consent to share / provide the transactions data feed / portfolio holdings / NAV etc. in respect
            of the User’s investments under Direct plan of all schemes to FIA.
            <br />
            <br />
            In view of services received by the User under this Agreement, the User hereby authorize and consent to FIA, AMC and Mutual Fund
            to share, disclose or transfer the User’s personal data and information including the details of his / her investments and
            transactions in the Schemes of the Mutual Fund with the investment advisor. This information may be disseminated by the AMC /
            Mutual Fund to the investment advisor and the same shall be solely used by the Advisor for the purpose of collating the User’s
            portfolio details under the said financial services Advisory / Execution Agreement.
          </DialogContentText>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            The User hereby agrees to indemnify, defend and hold harmless the AMC / Mutual Fund against any regulatory action, damage or
            liability that they may suffer, incur or become subject to in connection thereof or arising from sharing, disclosing and
            transferring of the aforesaid information.
            <br />
            <br />
            The User hereby acknowledges that the investment advisor has entered into an agreement with the AMC / Mutual Fund for accepting
            transaction feeds I / We further acknowledge and agree that in the event such agreement between the investment advisor and the
            AMC / Mutual Fund was to be terminated due to any reason, the User shall submit transactions in the schemes of the Mutual Fund
            directly to the AMC / Mutual Fund through other modes of transactions permitted by the AMC / Mutual Fund.
          </DialogContentText>
          <br />
          <br />
          <Typography id="responsive-dialog-title" variant="h3">
            {'Links to other sites '}
          </Typography>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            The App / Website / Services may contain links, information or pointers to other websites or services for payments, information
            verifications, information processing, transaction processing or other required / appropriate services but user should not infer
            or assume that FINVESTA operates, controls, manages or is otherwise connected with these other websites. When user click on a
            link within the App / Website, FINVESTA may or may not warn user that you have left the App / Website and are subject to the
            terms and conditions, disclaimers (including privacy policies) of another website or its partners & service providers. Please be
            careful to read the terms of use and privacy policy of any other website before you provide any confidential information or
            engage in any transactions. The user should not rely on the terms of FINVESTA to govern their use of another website. FINVESTA
            is not responsible for the content or practices of any other website even if it links to the site and even if the website is
            operated by a company affiliated or otherwise connected with FIA. You acknowledge and agree that FINVESTA is not responsible or
            liable to user for any content or other materials hosted and served from any website other than the App / Website.
          </DialogContentText>
          <br />
          <br />
          <Typography id="responsive-dialog-title" variant="h3">
            {'Consideration Terms '}
          </Typography>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            FINVESTA shall have the right to charge its users a fee for use of its platform and services as set out in the Fees and Charges
            section on the Website / App. FINVESTA may change fee structure as it determines in its sole discretion from time to time and
            notice regarding the same shall be intimated to you adequately in advance prior to such change in fee structure. All charges and
            fees shall be exclusive of taxes and all Government taxes including but not limited to GST shall be payable by you. All charges
            shall be non-transferable.
          </DialogContentText>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            All payments shall be made by Credit Card, Debit Card, UPI, Mobile Wallet, Net Banking, OTM, e-mandate / Bank Mandate or such
            other method as FINVESTA may specify from time to time.
            <br />
            <br />
            Requests made for purchase of any mutual fund scheme shall be processed by the respective mutual funds only after funds
            sufficient to cover the purchase price and other costs and charges have been received by the respective mutual funds. Payments
            towards the purchase price and other costs and charges shall be made by user through the payment gateway or other electronic
            means. The user shall ensure that payments for purchase of mutual fund shall be made through your own Bank account and in case
            of a joint Bank Account you shall be one of the holder of such Bank Account and should also be authorized by the other Bank
            Account holder for making such purchase. All payments should be through legitimate source and should be in compliance with the
            policies and guidelines laid down by RBI, NPCI, SEBI, and other regulatory body. The user is aware that if any investment is
            made through any third party Account then the same is liable to be rejected by FINVESTA or the AMC.
          </DialogContentText>
          <br />
          {/* <DialogContentText sx={{ color: '#282828' }} variant="h5">
                        FINVESTA shall have the right to charge its users a fee for use of its platform and services as set out in the Fees and
                        Charges section on the Website / App. FINVESTA may change fee structure as it determines in its sole discretion from time to
                        time and notice regarding the same shall be intimated to you adequately in advance prior to such change in fee structure. All
                        charges and fees shall be exclusive of taxes and all Government taxes including but not limited to GST shall be payable by
                        you. All charges shall be non-transferable.
                    </DialogContentText><br /> */}
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            I / We have not received nor have been induced by any rebate or gifts.
          </DialogContentText>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            When you make investment at FINVESTA platform, the investment amount goes directly to the Mutual Fund Houses basis of selection
            of the user. At no time, FINVESTA receives the investment amount. FINVESTA does not have any role to play in the investments
            that a Mutual fund makes in the market. Upon making such investment, user enter into bilateral contract with the Mutual Fund
            House or AMC. The user understands that mutual fund investments are subject to market risk. The user should read all Offer
            Documents including the Scheme Information Document, Key Information Memorandum and Addenda for all the mutual fund schemes that
            you invest. By Investing in a Mutual Fund Scheme, it is deemed that the user have read the offer document completely and are
            agreeing with the terms laid down in such offer document.
            <br />
            <br />
            Upon investment, units are allocated by Mutual funds as per applicable NAV, which is not under the control of FIA. FINVESTA does
            not warrant that the calculation of NAV and units allotted by Mutual funds are correct. In case if the user notices any
            discrepancy, FINVESTA customer support team can only help the user to resolve the query through AMC. However, the decision of
            AMC shall prevail and FIA shall have no role to play in that decision making.
            <br />
            <br />I confirm that for investments in any units of the scheme I have read and understood the content of the Scheme Information
            Documents/Statement of Additional Information of the scheme. I have also read and understood the terms, conditions, details,
            rules and regulations governing the scheme.
          </DialogContentText>
          <br />
          <br />
          <Typography id="responsive-dialog-title" variant="h3">
            {'Confidentiality '}
          </Typography>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            The user shall keep confidential information received by FINVESTA pursuant to this Agreement, even after termination of this
            Agreement. The user agree to protect the proprietary information of FINVESTA to which the user gain access to with the same
            standard of care and procedures used to protect own proprietary information of similar importance but at all times using
            reasonable degree of care.
            <br />
            <br />
            The user agree not to use or disclose the information provided under the service to any third party including any discussion
            Forums or for any unauthorized illegal purpose or for commercial usage. The user also agree to use the information provided
            under the plan strictly for personal purpose. The user shall not recompile, disassemble, copy, modify, distribute, transmit,
            display, perform, reproduce, publish or create derivative works from, transfer, or sell any information, services etc. accessed
            here. The user agree that any unauthorized use of FINVESTA information or systems shall be unlawful and may subject to civil or
            criminal actions.
          </DialogContentText>
          <br />
          <br />
          <Typography id="responsive-dialog-title" variant="h3">
            {'Termination of Agreement'}
          </Typography>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            The user agree that FIA, in its sole discretion, for any or no reason, and without penalty, may suspend or terminate your
            account (or any part thereof) or your use of the App and Website, at any time. FINVESTA may also in its sole discretion block,
            restrict, disable, suspend or terminate your access to the App and the Website, or any part thereof, with or without notice. The
            user agree that any termination of your access to the Website and / or the App or any account you may have or portion thereof
            may be effected without prior notice, and you agree that FINVESTA will not be liable to you or any third party for any such
            termination or interruption. Any suspected fraudulent, abusive or illegal activity may be referred to appropriate law
            enforcement authorities. These remedies are in addition to any other remedies FINVESTA may have at law or in equity. Upon
            termination for any reason, the user agree to immediately stop using the App / Website / Service. The User may terminate his /
            her account with FINVESTA by raising a termination request through the CST section of the App / Website. Such termination
            request can only be initiated when (i) the portfolio value of the User is Zero, and (ii) there are no monies due to FINVESTA
            from the User.
            <br />
            <br />
            <br />
            <Typography id="responsive-dialog-title" variant="h3">
            {'Limitation of liability and damages'}
          </Typography>
            <br />
            In no event, FINVESTA or its contractors, agents, licensors, directors, employees, associates, partners or suppliers will be
            liable to You for any special, indirect, incidental, consequential, punitive, reliance, or exemplary damages (including without
            limitation lost business opportunities, losses in investment products, lost revenues, or loss of anticipated profits or any
            other pecuniary or non-pecuniary loss or damage of any nature whatsoever) howsoever arising.
            <br />
            <br />
            In no event, FIA its directors, employees, agents will be liable to its user or any third party for any damages, liabilities,
            losses, and causes of action arising out of or relating to: (i) this Agreement; (ii) use of or access to the App and / or the
            Website or any reference Site / App / Platform / Service; or (iii) Your use or inability to use the Services provided by
            FINVESTA(including any and all materials) or any reference Sites / App / Platform / Service; or (iv) any other interactions with
            FIA or affiliates, or (v) any action caused by AMC or RTA or any other third party, however caused and whether arising in
            contract, tort including negligence, warranty or otherwise, beyond or in excess of ₹500, or the amount required as per
            Regulatory guidelines, whichever is lesser.
            <br />
            <br />
            The user acknowledge and agree that FINVESTA has offered its Services, set its prices, and entered into this Agreement in
            reliance upon the warranty disclaimers and the limitations of liability set forth herein, that the warranty disclaimers and the
            limitations of liability set forth herein reflect a reasonable and fair allocation of risk between You and FIA, and that the
            warranty disclaimers and the limitations of liability set forth herein form an essential basis of the bargain between You and
            FIA(FINVESTA) would not be able to provide the Services to you on an economically reasonable basis without these limitations.
            This paragraph shall survive the termination of this Agreement.
          </DialogContentText>
          <br />
          <br />
          <Typography id="responsive-dialog-title" variant="h3">
            {'Indemnification '}
          </Typography>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            The user agree to indemnify, save, and hold FIA/ the AMC / Mutual Fund, their affiliates, employees, officers, directors and
            partners harmless from any and all claims, losses, damages, and liabilities, costs and expenses, including without limitation
            legal fees and expenses, arising out of or related to: (i) Your use or misuse of the Services / App / Website; (ii) any
            violation by You of this Agreement or applicable laws; or (iii) any breach of the representations, warranties, and covenants
            made by You herein; or (iv) any act, neglect, misconduct or fraud on your part; or (v) sharing and or disclosing the information
            disclosed hereunder. FINVESTA reserves the right, at your expense, to assume the exclusive defense and control of any matter for
            which you are required to indemnify FIA, including rights to settle the claims. FINVESTA will use reasonable efforts to notify
            You of any claim, action, or proceeding brought by a third party that is subject to the foregoing indemnification upon becoming
            aware of it. This paragraph shall survive post termination of this Agreement.
          </DialogContentText>
          <br />
          <br />
          <Typography id="responsive-dialog-title" variant="h3">
            {'Disclaimer: No Warranties '}
          </Typography>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            To the extent permissible pursuant to applicable law, FINVESTA and its third-party partners disclaim all warranties or
            guarantees – whether statutory, express or implied – including, but not limited to, implied warranties of merchantability,
            fitness for a particular purpose, and non-infringement of proprietary rights. No advice or information, whether oral or written,
            obtained by You from FINVESTA or through the App / Website / Service will create any warranty or guarantee other than those
            expressly stated herein. For the purposes of this Disclaimer, you expressly agree that use of the Services on App / Website is
            at your sole risk.
            <br />
            <br />
            All information provided through the App or the Website is on an “AS IS” best effort basis. The user expressly agree that use of
            the App / Website / Service is at its sole risk. The App / Website / Service and any data, information, third party software,
            reference sites, services, or software made available in conjunction with or through the App / Website / Service are provided on
            an “as is” and “as available,” “with all faults” basis and without warranties or representations of any kind either express or
            implied.
            <br />
            <br />
            FINVESTA and any third party suppliers, affiliates, subsidiaries, licensors, employees, and partners do not warrant that the
            data, software, functions, or any other information offered on or through the app will be uninterrupted or free of errors,
            viruses or other harmful components and do not warrant that any of the foregoing will be corrected. FINVESTA and any third party
            suppliers, licensors, affiliates, subsidiaries and partners do not warrant or make any representations regarding the use or the
            results of the use of the App/Website / Service in terms of correctness, accuracy, reliability, or otherwise.
          </DialogContentText>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            You understand and agree that if you use, access, download, or otherwise obtain information, materials, or data through the App
            / Website / Service, the same shall be at your own discretion and risk and that you will be solely responsible for any damage to
            your property (including your computer system and / or other device) or loss of data that results from the download or use of
            such material or data. We do not authorize anyone to make any warranty on our behalf and user should not rely on any such
            statement. This paragraph shall survive even after the termination of this Agreement. In no event will FINVESTA be liable for
            any incidental, consequential, or indirect damages (including, but not limited to, damages for loss of profits, business
            interruption, loss of programs or information, and the like) arising out of the use of or inability to use the App / Website /
            Service. The user shall not solely rely on the views, representations (whether written or oral or otherwise), recommendations,
            opinions, reports, analysis, information or other statement made by FINVESTA or any of its agents, directors, officers or
            employees. In the event that you seek to make an investment pursuant to the information or recommendation provided by FIA, you
            shall do so at your own risk, and should consider your financial situation, objectives and needs and consult with your legal,
            business, tax and / or other professional advisors to determine the appropriateness and consequences of such an investment. The
            user agree that all the final decisions will be yours and FINVESTA shall not have any liability for consequences of such
            decisions.
          </DialogContentText>
          <br />
          <br />
          <Typography id="responsive-dialog-title" variant="h3">
            {'Ownership; Proprietary Rights '}
          </Typography>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            The App / Website / Service are owned and operated by FIA Technology Services Private Limited. The visual interfaces, graphics,
            design, compilation, information, computer code (including source code and object code), products, software, services, and all
            other elements of the Services and the App / Website provided by FINVESTA (hereafter Materials) are protected by Indian
            copyright, trade dress, patent, and trademark laws, international conventions, and all other relevant intellectual property and
            proprietary rights, and applicable laws. As between You and FIA, all Materials, trademarks, service marks, and trade names
            contained on the App / Website / Service are the property of FIA. The user agrees not to remove, obscure, or alter FINVESTA or
            any third party’s copyright, patent, trademark, or other proprietary rights notices affixed to or contained within or accessed
            in conjunction with or through the App / Website / Service. Except as expressly authorized by FIA, user agree not to sell,
            license, distribute, copy, modify, publicly perform or display, transmit, publish, edit, adapt, create derivative works from, or
            otherwise make unauthorized use of the Materials. FINVESTA reserves all rights not expressly granted in this Agreement. If You
            have comments regarding the App / Website / Service or ideas on how to improve it, contact to customer service. Please note that
            by doing so, You hereby irrevocably assign to FIA Technology Services Private Limited, and shall assign to FIA, all rights,
            title and interests in and to all ideas and suggestions and any and all worldwide intellectual property rights associated
            therewith. The user agree to perform such acts and execute such documents as may be reasonably necessary to perfect the
            foregoing rights.
          </DialogContentText>
          <br />
          <br />
          <Typography id="responsive-dialog-title" variant="h3">
            {'Modification of this Agreement'}
          </Typography>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            FINVESTA reserves the rights to change, modify, add, or remove terms of this Agreement (each, a change and collectively,
            changes) at any time by posting notification on the App / Website or otherwise communicating the notification to its users. The
            changes will become effective, and shall be deemed accepted by You, 24 hours after the initial posting and shall apply
            immediately on a going-forward basis with respect to Your use of the App / Website, availing the Services or for payment
            transactions initiated after the posting date. If You do not agree with any such change, the sole and exclusive remedy is to
            terminate the usages of the App / Website / Service. For certain changes, FINVESTA may be required under applicable law to give
            You advance notice, and FINVESTA will comply with such requirements. Your continued use of the App / Website / Service following
            the posting of changes will mean that the user has accepted and agree to the changes. Notice
            <br />
            <br />
            FINVESTA may provide You with notices and communications by e-mail, SMS, push notifications, regular mail or postings on the App
            / Website or by any other reasonable means. Except as otherwise set forth herein, notice to FINVESTA must be sent by courier to
            its address mentioned above or registered mail to [info@fiaglobal.com].
            <br />
            <br />
            FINVESTA shall send out all notices, information and other correspondence to you by email / sms at the email address / telephone
            number provided by the User. In the event any notice, information or other correspondence is sent to you via letter, such letter
            will be sent to the postal address that you have given as your Communication address. In case of any change in your email id and
            / or mobile number / Correspondence address, the user shall inform FINVESTA in advance in the prescribed format to carry out the
            necessary changes in its records.
            <br />
            <br />
            FINVESTA does not guarantee that electronic communications will be successfully delivered, or that they will be secure and virus
            free. FINVESTA will not be liable for any loss, damage, expense, harm or inconvenience caused as a result of an email being
            lost, delayed, intercepted, corrupted or otherwise altered or for failing to be delivered for any reason beyond our reasonable
            control. All correspondence will be in English.
            <br />
            <br />
            You agree to be contacted by FINVESTA and its representatives over phone or on registered email id with reference to the
            Services. You agrees & confirm that if your mobile number is registered in the Do Not Disturb (DND) list of TRAI, you may not
            receive SMS from FIA. The user agree to take steps to deregister from the DND list and shall not hold FINVESTA liable for
            non-receipt of SMS in the interim period.
          </DialogContentText>
          <br />
          <br />
          <Typography id="responsive-dialog-title" variant="h3">
            {'Waiver '}
          </Typography>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            The failure of FINVESTA to exercise or enforce any right or provision of this Agreement will not constitute a waiver of such
            right or provision. Any waiver of any provision of this Agreement will be effective only if in writing and signed or digitally
            accepted by FIA
            <br />
            <br />
            {/* <br /> */}
            <Typography id="responsive-dialog-title" variant="h3">
            {'Dispute Resolution'}
          </Typography>
            <br />
            In case of any dispute, controversy or claim arises under this Agreement , in relation to App / Website / Service, including any
            question regarding the existence, validity or termination of this Agreement or any specific terms contained herein (hereinafter
            Dispute), the parties shall use all reasonable endeavors to resolve such Dispute amicably. If the parties are unable to resolve
            the Dispute amicably within 30 days of the notice of such Dispute, FINVESTA may elect to resolve any Dispute by a binding
            arbitration in accordance with the provisions of the Indian Arbitration & Conciliation Act, 1996 (hereinafter Act). Such Dispute
            shall be arbitrated on an individual basis and shall not be consolidated in any arbitration with any claim or controversy of any
            other party. The Dispute shall be resolved by a sole arbitrator, appointed by mutual consent of both the Parties in accordance
            with the Act. The seat of the arbitration shall be Gurgaon and the language of this arbitration shall be English. Either user or
            FIA may seek any interim or preliminary relief from a court of competent jurisdiction necessary to protect the rights or the
            property belonging to the user or FIA (or any of our agents, suppliers, and subcontractors), pending the completion of
            arbitration. The arbitral proceeding shall be confidential, and neither the user and nor the FIA shall disclose the existence,
            content or results of any arbitration, except as may be required by law or for purposes of enforcing the arbitration award. All
            administrative fees and expenses of arbitration will be divided equally between You and FIA. In all arbitrations, each party
            will bear the expense of its own lawyers and preparation. This paragraph shall survive termination of this Agreement.
            <br />
            <br />
            <Typography id="responsive-dialog-title" variant="h3">
            {'Governing Law and Forum for Disputes'}
          </Typography>
            <br />
            Subject to the Dispute Resolution section above, the user agree that any claim or dispute you may have against FINVESTA must be
            resolved by a court having jurisdiction in Gurgaon, India. The user agree to submit to the jurisdiction of the courts located at
            Gurugaon, India, for the purpose of litigating all such claims or disputes. This Agreement shall be governed by Indian law. This
            paragraph shall survive termination of this Agreement.
          </DialogContentText>
          <br />
          <Typography id="responsive-dialog-title" variant="h3">
            {'Severability '}
          </Typography>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            If any provision of this Agreement is held to be unlawful, void, invalid or otherwise unenforceable, then that provision will be
            limited or eliminated from this Agreement to the minimum extent required, and the remaining provisions will remain valid and
            enforceable.
          </DialogContentText>
          <br />
          <Typography id="responsive-dialog-title" variant="h3">
            {'Survival '}
          </Typography>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            Upon termination of this Agreement, any provision, which, by its nature or express terms should survive, will survive such
            termination or expiration as applied to transfers and relationship prior to such termination or expiration.
          </DialogContentText>
          <br />
          <Typography id="responsive-dialog-title" variant="h3">
            {'Headings  '}
          </Typography>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            The heading references herein are for convenience purposes only and they do not constitute a part of these T&Cs and will not be
            deemed to limit or affect any of the provisions hereof.
          </DialogContentText>
          <br />
          <Typography id="responsive-dialog-title" variant="h3">
            {'Entire agreement   '}
          </Typography>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            These terms and conditions are the entire agreement between user and FINVESTA relating to the subject matter hereof and this
            Agreement will not be modified except by a change to this Agreement made by FINVESTA in accordance with the terms of this
            Agreement.
          </DialogContentText>
          <br />
          <Typography id="responsive-dialog-title" variant="h3">
            {'Force Majeure '}
          </Typography>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            If the whole or any part of the performance of the respective obligations of the parties hereunder is prevented or delayed by
            reasons of natural calamities, war, arson, civil disturbance, , unavailability of any communication system including Internet,
            breach or virus in the processes or payment mechanism, sabotage, acts of government, computer hacking, unauthorized access to
            computer data and storage devices, computer crashes, breach of security and encryption codes and such other reasons beyond the
            reasonable control of a person (each a “Force Majeure Event”), then to the extent either party shall be prevented or delayed
            from performing all or any part of their respective obligations under this Agreement despite due diligence and reasonable
            efforts to do so, then such party shall be excused from performance hereunder for so long as reasons of Force Majeure Event
            continue. A Force Majeure Event shall not affect the payment obligations of the parties unless there is legal bar / embargo to
            the making of the payments.
          </DialogContentText>
          <br />
          <Typography id="responsive-dialog-title" variant="h3">
            {'Assignment'}
          </Typography>
          <br />
          <DialogContentText sx={{ color: '#282828' }} variant="h5">
            The right to use the App / Website / Service is personal to user only and is not transferable by assignment, sublicense, or any
            other method to any other person whatsoever.
          </DialogContentText>
          <br />
        </DialogContent>

        <DialogActions>
          {/* <Button autoFocus onClick={handleClose}>
    Disagree
  </Button>
  <Button onClick={handleClose} autoFocus>
    Agree
  </Button> */}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default Terms;
